import React from 'react';
import PropTypes from 'prop-types';

import TextareaCounter from './../../FormComponents/TextareaCounter';

export default function Memberships({ details, onChange, disabled, preferences }) {
  const { schema } = preferences;
  return (
    <div className="memberships">
      <div className="memberships__row">
        <p className="memberships__row__subheading">
          How would you like us to respond if the customer asks the following?
        </p>
      </div>

      <div className="memberships">
        {schema?.hold_customer_membership_info &&
        <div className="memberships__row">
          <p className="memberships__row__label">
          {schema?.hold_customer_membership_info?.description || `Can I put my membership on hold?`}
          </p>
          <div className="memberships__row__input">
            <TextareaCounter
              rows="3"
              placeholder=""
              name="hold_customer_membership_info"
              value={details.hold_customer_membership_info}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>}
        {schema?.membership_cancellation_policy &&
        <div className="memberships__row">
          <p className="memberships__row__label">
          {schema?.membership_cancellation_policy?.description || `What is your membership cancellation policy?`}
          </p>
          <div className="memberships__row__input">
            <TextareaCounter
              rows="3"
              placeholder=""
              name="membership_cancellation_policy"
              value={details.membership_cancellation_policy}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>}
      </div>
    </div>
  );
}

Memberships.defaultProps = {
  onChange: () => {},
  // setRef: () => {},
  details: {},
  errors: {},
  disabled: false,
};

Memberships.propTypes = {
  onChange: PropTypes.func,
  // setRef: PropTypes.func,
  details: PropTypes.shape(),
  // errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
